// components/interview-page/TabSwitchModal.jsx
import { useEffect, useRef } from "react"

const TabSwitchModal = ({ isVisible, onDismiss }) => {
  const audioCtx = useRef(null)

  useEffect(() => {
    if (!isVisible) return

    audioCtx.current = new (window.AudioContext || window.webkitAudioContext)()
    const oscillator = audioCtx.current.createOscillator()
    const gainNode = audioCtx.current.createGain()

    oscillator.connect(gainNode)
    gainNode.connect(audioCtx.current.destination)

    oscillator.type = "sine"
    oscillator.frequency.setValueAtTime(880, audioCtx.current.currentTime)
    oscillator.frequency.exponentialRampToValueAtTime(
      440,
      audioCtx.current.currentTime + 0.3,
    )
    gainNode.gain.setValueAtTime(0.3, audioCtx.current.currentTime)
    gainNode.gain.exponentialRampToValueAtTime(
      0.001,
      audioCtx.current.currentTime + 0.4,
    )

    oscillator.start()
    oscillator.stop(audioCtx.current.currentTime + 0.4)

    return () => {
      try {
        audioCtx.current?.close()
      } catch (_) {}
    }
  }, [isVisible])

  if (!isVisible) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: "rgba(0,0,0,0.45)", backdropFilter: "blur(4px)" }}
    >
      <div
        className="bg-white mx-4"
        style={{
          borderRadius: 0,
          width: "100%",
          maxWidth: "420px",
          boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
          fontFamily: "'IBM Plex Sans', sans-serif",
        }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 px-6 py-4 border-b border-zinc-200">
          <div
            className="w-8 h-8 bg-red-50 border border-red-200 flex items-center justify-center shrink-0"
            style={{ borderRadius: 0 }}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M8 2L14 13H2L8 2Z"
                stroke="#ef4444"
                strokeWidth="1.5"
                fill="none"
                strokeLinejoin="round"
              />
              <path
                d="M8 6V9"
                stroke="#ef4444"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <circle cx="8" cy="11" r="0.75" fill="#ef4444" />
            </svg>
          </div>
          <p className="text-sm font-bold text-zinc-900 tracking-tight">
            Suspicious Activity Detected
          </p>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <p className="text-[15px] text-zinc-700 leading-relaxed mb-1 font-bold">
            Candidate has moved away from the current tab.
          </p>
          <p className="text-sm text-zinc-500 leading-relaxed">
            Candidate might be using interview helper tools like Final Round AI.
            Ask the candidate to reshare their screen with full-screen enabled
            and ensure that all tabs are visible.
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 pb-5">
          <button
            onClick={onDismiss}
            className="w-full bg-zinc-900 hover:bg-zinc-700 text-white text-xs font-bold uppercase tracking-widest py-3 transition-colors"
            style={{ borderRadius: 0 }}
          >
            Return to Interview
          </button>
        </div>
      </div>
    </div>
  )
}

export default TabSwitchModal
